import React from "react";
import { Spacer } from "@dspworkplace/ui";
import styled from 'styled-components';
import WorkHourComplianceWarning from "./WorkHourComplianceWarning"
import StationResetTime from './StationResetTime/index';
import { AccessCheck, IsGranted } from "../../../security";

const Container = styled.div`
    display: grid;
    width: 100%;
`;

const App = () => {
    return (
        <Container>
            <IsGranted feature={AccessCheck.features.LABOR_COMPLIANCE_ALERTS} ops={AccessCheck.OPS.U} renderWarning={true}>
                <>
                    <WorkHourComplianceWarning />
                    <Spacer bottom={20} />
                    <StationResetTime />
                    <Spacer bottom={20} />
                </>
            </IsGranted>
        </Container>
    );
}
export default App;